/** 동호수 정규식 생성기 */
export default function dongho(
  dong: string | null | undefined,
  ho: string | null | undefined
) {
  if (!dong && !ho) return '';
  // 호만 검색: -701호, -701 등 (앞에 다른 숫자가 붙지 않도록)
  if (!dong) return `-${ho}(호)?($|[^0-9])`;
  // 동만 검색: 101동-, 101- 등 (뒤에 다른 숫자가 붙지 않도록)
  if (!ho) return `(^|[^0-9])${dong}(동)?-`;
  // 동호 모두 검색: 101동-701호, 101-701 등
  return `(^|[^0-9])${dong}(동)?-${ho}(호)?($|[^0-9])`;
}
